import { FilesState } from 'types';
import { DocumentTypes } from 'types/inspection';

const initialSingleFileState = {
  file: {
    fileId: '',
    url: '',
    fileName: '',
    originalName: '',
    status: '',
    createdAt: '',
    mergedFileData: undefined,
    isOCR: undefined,
  },
  fileUnavailable: false,
};

const initialFilesState: FilesState = {
  source: initialSingleFileState,
  target: initialSingleFileState,
  isFetchingInspectionFiles: false,
  filesList: null,
  fileErrorType: undefined,
  requestKeys: { source: '', target: '' },
  multipleFileStatus: { source: false, target: false },
  ocrStatus: { source: '', target: '' },
  shapesJobStatus: '',
  ocrHasRun: false,
  isCreationCancelled: false,
  activeFileTransferIds: {
    [DocumentTypes.source]: null,
    [DocumentTypes.target]: null,
  },
  pendingReorderData: null,
  readyFilesQueue: [],
  pendingIdUpdates: [],
  failedUploads: [],
  cancelledFileIds: [],
  cancelledFilenames: [],
  fileToBatchMap: {},
  cancelledBatchKeys: [],
};

export { initialSingleFileState, initialFilesState };
